import { all, fork } from "redux-saga/effects";

//public
import AccountSaga from "./auth/register/saga";
import AuthSaga from "./auth/login/saga";
import ForgetSaga from "./auth/forgetpwd/saga";
import ProfileSaga from "./auth/profile/saga";
import LayoutSaga from "./layout/saga";
import serviceSaga from "./service/saga";
import dashboardSaga from "./dashboard/saga";
import globalThresholdSaga from "./global-threshold/saga";
import onboardingSaga from "./onboarding/saga";
import oncallsSaga from "./oncall/saga";
import metricSaga from "./metric/saga";
import thresholdSaga from "./threshold/saga";
import teamSaga from "./team/saga";
import organizationSaga from "./organization/saga";
import alcomScoreDashboardSaga from "./alcomscoredashboard/saga";
import onCallPolicySaga from "./onCallPolicy/saga";
import inviteConfirmationSaga from "./inviteconfirmation/saga";
import opsgenieTeamsSaga from "./opsgenie/saga";
import pagerdutyServicesSaga from "./pagerduty/saga";
import alertSaga from "./alert/saga";
import newRelicSaga from "./newrelic/saga";
import datadogSaga from "./datadog/saga";
import splunkSaga from "./splunk/saga"
import emailConfirmationSaga from "./emailconfirmation/saga";
import serviceEmailConfirmationSaga from "./serviceemailconfirmation/saga";
import cloudResourcesSaga from "./cloudresource/saga";
import resetPasswordSaga from "./auth/resetpassword/saga";
import paymentSaga from "./pricing/saga";
import alertLogSaga from './alertlog/saga';
import DaemonSaga from './daemon/saga';
import GCPSaga from './gcp/saga';
import GCPAlertsSaga from './gcp_alert/saga';
import GCPThresholdSaga from './gcp_threshold/saga';
import alertAnalyticsSaga from './alertanalytics/saga';
import AzureSaga from './azure/saga'
import AzureAlertSaga from "./azure_alert/saga";
import AzureThresholdSaga from "./azure_threshold/saga";
import msTeamsSaga from "./msteams/saga";
import appDynamicsSaga from "./appDynamics/saga";
import {dynatraceSaga} from "./dynatrace/saga";
import pingMonitorSaga from "./pingmointoring/saga";
import rcaSaga from "./rca/saga";

import incidentsSaga from "./statuspage/saga";

import ociSaga from "./oci/saga";
import sentrySaga from "./sentry/saga";
import lokiSaga from "./loki/saga";
import coralogixSaga from "./coralogix/saga";
import subscriptionsSaga from "./subscriptions/saga";
import GrafanaSaga from "./grafana/saga";
import SignozSaga from "./signoz/saga";



export default function* rootSaga() {
  yield all([
    //public
    fork(AccountSaga),
    fork(AuthSaga),
    fork(ForgetSaga),
    fork(ProfileSaga),
    fork(LayoutSaga),
    fork(dashboardSaga),
    fork(serviceSaga),
    fork(globalThresholdSaga),
    fork(onboardingSaga),
    fork(oncallsSaga),
    fork(metricSaga),
    fork(thresholdSaga),
    fork(organizationSaga),
    fork(alcomScoreDashboardSaga),
    fork(onCallPolicySaga),
    fork(inviteConfirmationSaga),
    fork(emailConfirmationSaga),
    fork(serviceEmailConfirmationSaga),
    fork(teamSaga),
    fork(opsgenieTeamsSaga),
    fork(pagerdutyServicesSaga),
    fork(alertSaga),
    fork(newRelicSaga),
    fork(datadogSaga),
    fork(splunkSaga),
    fork(cloudResourcesSaga),
    fork(resetPasswordSaga),
    fork(paymentSaga),
    fork(alertLogSaga),
    fork(GCPSaga),
    fork(GCPAlertsSaga),
    fork(GCPThresholdSaga),
    fork(alertAnalyticsSaga),
    fork(AzureSaga),
    fork(AzureAlertSaga),
    fork(AzureThresholdSaga),
    fork(msTeamsSaga),
    fork(appDynamicsSaga),
    fork(dynatraceSaga),
    fork(pingMonitorSaga),
    fork(rcaSaga),
    fork(DaemonSaga),
    fork(incidentsSaga),
    fork(ociSaga),
    fork(sentrySaga),
    fork(lokiSaga),
    fork(coralogixSaga),
    fork(subscriptionsSaga),
    fork(GrafanaSaga),
    fork(SignozSaga)
  ]);
}
